export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "avalon-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "avalon-themeWrapLive" */'./LiveThemeImporter'),
  },
};
